import React from "react";
// The grey file beside this one belongs to the legacy tree's own NoResults; it
// stays on disk until legacy is retired.
import gundi_no_results from "../../images/gundi_no_results_green.png"

type NoResultsProps = {
    headerMsg: string,
    labelMsg: string | JSX.Element
}

const NoResults = ({
    headerMsg,
    labelMsg
}: NoResultsProps) => {
    return (
        <div className="mx-auto">
            <img src={gundi_no_results} alt="empty results icon" className="mx-auto cursor-auto h-[180px] mb-6" />
            <h2 className="text-center text-xl mb-1 transition-colors duration-300">{headerMsg}</h2>
            {/* Brand Text Secondary: on the card lists this sits straight on the page
                tint, and it stays readable on the near-white tables too. */}
            <h3 className="text-center text-ui-text-secondary-text mb-4 transition-colors duration-300">{labelMsg}</h3>
        </div>
    )
}

export default NoResults;